export enum GameId {
  Solitaire = 'solitaire',
  Blocks = 'blocks',
  Blackjack = 'blackjack',
  TwentyOne = 'twentyone',
  Slots = 'slots',
  Plinko = 'plinko',
  Marbles = 'marbles',
  VideoPoker = 'videopoker',
  HiLo = 'hilo',
  SlotsBaseball = 'slots-baseball',
  Bingo = 'bingo',
}
